export default {
  methods: {
    roundVal(decimalPlaces, roundDecimals, value) {
      let returnVal = value;
      if (returnVal === undefined || returnVal === null || Number.isNaN(returnVal) || decimalPlaces === -1) {
        return returnVal;
      }
      if (!roundDecimals) {
        returnVal = this.truncateDecimals(decimalPlaces, returnVal);
      }
      return returnVal.toFixed(decimalPlaces);
    },
    truncateDecimals(decimalPlaces, value) {
      const numS = value.toString();
      const decPos = numS.indexOf('.');
      const substrLength = decPos === -1 ? numS.length : 1 + decPos + decimalPlaces;
      const trimmedResult = numS.substr(0, substrLength);
      const finalResult = Number.isNaN(trimmedResult) ? 0 : trimmedResult;

      return parseFloat(finalResult);
    }
  }
};
